import { post, get, put, del as requestDel } from '@/utils/request';

// 新增/修改设备告警分类
export function DeviceAlarmTypeAdd(Data) {
  if (Data.id && Data.id > 0) {
    return put('/api/v1/device-alarm-type/' + Data.id, Data);
  }
  return post('/api/v1/device-alarm-type', Data); 
}

// 设备告警分类分页列表
export function DeviceAlarmTypeList(Data) {
  return get('/api/v1/device-alarm-type/page', Data); 
}

// 设备告警分类删除
export function DeviceAlarmTypeDel(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return requestDel('/api/v1/device-alarm-type/' + id); 
}

// 设备告警分类详情
export function DeviceAlarmTypeDetail(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return get('/api/v1/device-alarm-type/detail', { id }); 
}
